import { render } from "./Calculator.vue?vue&type=template&id=20123974&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"

import "./Calculator.vue?vue&type=style&index=0&id=20123974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20123974"]])

export default __exports__